// 請求・支払（締め）ビュー（中身/TMS・Firestore連動）。trips → 得意先別請求／協力会社別支払 と 傭車取り分の締め集計。
// お伺い書(chargesheet)と同じ buildSheets を使用。デモは同梱 sample.trips.json（架空データ。scripts/make-sample-data.mjs が生成）。
import { buildSheets, listMonths, totals } from '../data/analytics/chargesheet.js'
import { COLLECTIONS, listDocs } from '../data/collections.js'
import { supabaseReady } from '../supabase.js'
import { resolveMonth, setSelectedMonth } from '../data/selectedMonth.js'
import sampleTrips from './sample.trips.json'
import { allowSample, DEMO_TAG, noDataHtml } from '../data/demoData.js'

const YEN = (n) => '¥' + Math.round(Number(n) || 0).toLocaleString('ja-JP')
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
const monthOf = (t) => t.month || (t.date ? String(t.date).slice(0, 7) : '')

const B = { el: null, ctx: {}, month: null, months: [], sheets: {}, trips: [], online: false, fetchError: false, isSample: false }

function styleOnce() {
  if (document.getElementById('bl-style')) return
  const s = document.createElement('style'); s.id = 'bl-style'
  s.textContent = `
  .bl{display:flex;flex-direction:column;gap:12px}
  .bl-bar{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
  .bl-bar select{font-family:inherit;font-size:13px;padding:6px 10px;border:1px solid var(--e1);border-radius:8px;background:var(--card);color:var(--text)}
  .bl-demo{font-size:11px;color:var(--signal);background:transparent;border:1px solid var(--accent);border-radius:999px;padding:3px 10px}
  .bl-open{margin-left:auto;font-size:12px;color:var(--text);text-decoration:none;background:var(--card);border:1px solid var(--e1);border-radius:8px;padding:6px 12px}
  .bl-kpis{display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:10px}
  .bl-kpi{background:var(--card);border:1px solid var(--e1);border-radius:10px;padding:11px 13px}
  .bl-kpi .k{font-size:10.5px;color:var(--muted)}.bl-kpi .v{font-size:19px;font-weight:700;font-variant-numeric:tabular-nums;margin-top:2px}
  .bl-kpi.bill .v{color:var(--text)}.bl-kpi.pay .v{color:var(--accent)}.bl-kpi.pos .v{color:var(--pos)}
  .bl-grid{display:grid;grid-template-columns:1fr 1fr;gap:13px}
  @media(max-width:960px){.bl-grid{grid-template-columns:1fr}}
  .bl-panel{border:1px solid var(--e1);border-radius:12px;overflow:hidden;background:var(--card)}
  .bl-panel .cap{padding:9px 13px;font-size:12px;font-weight:700;border-bottom:1px solid var(--e1)}
  .bl-panel.bill .cap{background:var(--head);color:var(--text)}.bl-panel.pay .cap{background:var(--head);color:var(--signal)}
  .bl-scroll{max-height:56vh;overflow:auto}
  table.bl-tbl{width:100%;border-collapse:collapse;font-size:11.5px}
  .bl-tbl th,.bl-tbl td{padding:5px 9px;border-bottom:1px solid var(--e3);text-align:left;white-space:nowrap}
  .bl-tbl th{position:sticky;top:0;background:var(--head);color:var(--text);font-size:10.5px;z-index:1}
  .bl-tbl td.n,.bl-tbl th.n{text-align:right;font-variant-numeric:tabular-nums}
  .bl-tbl tr.tot td{border-top:2px solid var(--e1);font-weight:700;background:var(--head)}
  .tb{font-size:9.5px;font-weight:700;color:var(--pos);background:transparent;border-radius:4px;padding:0 5px;margin-left:4px}
  .bl-note{font-size:11px;color:var(--muted);line-height:1.6}
  .bl-tbl td.a,.bl-tbl th.a{text-align:right;padding-left:0}
  .bl-inv{font-size:10.5px;font-weight:700;color:var(--text);text-decoration:none;border:1px solid var(--e1);border-radius:6px;padding:2px 8px;white-space:nowrap}
  .bl-inv:hover{border-color:var(--accent)}
  `
  document.head.appendChild(s)
}

export async function renderBilling(el, ctx = {}) {
  styleOnce()
  B.el = el
  B.ctx = ctx
  B.online = !ctx.demo && supabaseReady
  B.fetchError = false
  el.innerHTML = '<div class="ct-state is-loading"><b class="ct-state__t">集計しています…</b><span>選択月の請求・支払を集計しています</span></div>'
  let trips = sampleTrips
  if (B.online) {
    // 実データ0件のときサンプルへ落ちてよいかは共通判定 allowSample（設定 settings/display）に委ねる
    try { const t = await listDocs(COLLECTIONS.trips); if (t && t.length) trips = t; else if (!allowSample(B.online)) trips = [] }
    catch { B.online = false; B.fetchError = true }
  }
  // サインイン済みの実fetch失敗はサンプルへフォールバックせず is-error を主表示にする
  // （サンプル描画は明示的なデモ状況＝online初期値false のときだけ。2026-08-27 負債解消）
  if (B.fetchError) { B.trips = []; B.sheets = {}; B.isSample = false; paintFetchError(); return }
  B.isSample = trips === sampleTrips
  // 実データ0件＋デモ表示OFF＝正直に空を出す（架空の実績を本物の顔で並べない。2026-08-27 案C）
  if (!B.isSample && !trips.length) { B.trips = []; B.sheets = {}; paintNoData(); return }
  B.trips = trips
  B.sheets = buildSheets(trips)
  const picked = resolveMonth(listMonths(B.sheets))
  B.months = picked.months
  B.month = picked.month
  paint()
}

// 実fetch失敗（デモ意図とは別）の主表示。サンプルデータは描画しない
function paintFetchError() {
  B.el.innerHTML = '<section class="bl"><div class="ct-state is-error"><b class="ct-state__t">データを読み込めませんでした</b><span>保存済みの実データを取得できませんでした。誤認を避けるためサンプルは表示していません。接続を確認して再試行してください</span><button type="button" class="btn" id="bl-retry">再試行</button></div></section>'
  const retry = B.el.querySelector('#bl-retry'); if (retry) retry.addEventListener('click', () => { renderBilling(B.el, B.ctx) })
}

// 実データ0件＋デモデータ表示OFF（既定）の主表示。サンプルは描かない
function paintNoData() {
  B.el.innerHTML = `<section class="bl">${noDataHtml('請求・支払')}</section>`
}

function panel(kind, arr) {
  const isBill = kind === 'seikyu'
  const label = isBill ? '傭車料' : '傭車料'
  const cap = `<div class="cap">${isBill ? '得意先別 ご請求' : '協力会社別 お支払'}（${arr.length}社）</div>`
  if (!arr.length) {
    return `<div class="bl-panel ${isBill ? 'bill' : 'pay'}">${cap}
      <div class="ct-state is-empty"><b class="ct-state__t">この月の${isBill ? 'ご請求' : 'お支払'}はありません</b><span>月を切り替えるか、運行実績を取り込んでください</span></div></div>`
  }
  // 得意先の行からその月の請求書（実物様式・A4横）を開く。運賃お伺い書の発行導線と流儀をそろえる
  const inv = (g) => `<a class="bl-inv" href="#/invoice?m=${encodeURIComponent(B.month || '')}&k=${encodeURIComponent(g.key || '')}" title="${esc(g.name)} の請求書">請求書</a>`
  const rows = arr.map((g) => `<tr>
      <td>${esc(g.name)}${g.tnum ? '<span class="tb">T</span>' : ''}</td>
      <td class="n">${g.n}</td><td class="n">${YEN(g.sub)}</td><td class="n">${YEN(g.tax)}</td>
      <td class="n">${g.toll ? YEN(g.toll) : '—'}</td><td class="n">${YEN(g.total)}</td>
      <td class="a">${isBill ? inv(g) : ''}</td></tr>`).join('')
  const T = arr.reduce((s, g) => ({ n: s.n + g.n, sub: s.sub + g.sub, tax: s.tax + g.tax, toll: s.toll + g.toll, total: s.total + g.total }), { n: 0, sub: 0, tax: 0, toll: 0, total: 0 })
  const amt = isBill ? '運賃' : '傭車料'
  return `<div class="bl-panel ${isBill ? 'bill' : 'pay'}">${cap}
      <div class="bl-scroll"><table class="bl-tbl">
        <thead><tr><th>${isBill ? '得意先' : '協力会社'}</th><th class="n">件数</th><th class="n">${amt}(税抜)</th><th class="n">消費税</th><th class="n">立替通行料</th><th class="n">合計</th><th class="a">${isBill ? '発行' : ''}</th></tr></thead>
        <tbody>${rows}
          <tr class="tot"><td>合計</td><td class="n">${T.n}</td><td class="n">${YEN(T.sub)}</td><td class="n">${YEN(T.tax)}</td><td class="n">${YEN(T.toll)}</td><td class="n">${YEN(T.total)}</td><td class="a"></td></tr>
        </tbody></table></div></div>`
}

function paint() {
  const el = B.el
  const seikyu = (B.sheets[B.month] && B.sheets[B.month].seikyu) || []
  const shiharai = (B.sheets[B.month] && B.sheets[B.month].shiharai) || []
  const tb = totals(B.sheets, B.month, 'seikyu')
  const tp = totals(B.sheets, B.month, 'shiharai')
  // 傭車取り分＝当月の傭車運行の（請求運賃 − 支払傭車料）
  let ariUri = 0, ariPay = 0, ariN = 0
  for (const t of B.trips) { if (monthOf(t) === B.month && t.kind === 'charter') { ariUri += Number(t.fare) || 0; ariPay += Number(t.charterCost) || 0; ariN++ } }
  const ari = ariUri - ariPay
  const opts = B.months.map((m) => `<option value="${m}" ${m === B.month ? 'selected' : ''}>${m.replace('-', '年')}月</option>`).join('')
  el.innerHTML = `
    <section class="bl">
      <div class="bl-bar">
        <select id="bl-month">${opts}</select>
        ${B.isSample ? `<span class="bl-demo">${DEMO_TAG}</span>` : ''}
        <button type="button" class="bl-open" data-prototype="billing">詳細プロトタイプ ↗</button>
      </div>
      <div class="bl-kpis">
        <div class="bl-kpi bill"><div class="k">総請求（得意先・税込）</div><div class="v">${YEN(tb.total)}</div><div class="k">${tb.parties}社・${tb.n}件</div></div>
        <div class="bl-kpi pay"><div class="k">総支払（協力会社・税込）</div><div class="v">${YEN(tp.total)}</div><div class="k">${tp.parties}社・${tp.n}件</div></div>
        <div class="bl-kpi pos"><div class="k">利用運送 粗利</div><div class="v">${YEN(ari)}</div><div class="k">傭車 ${ariN}件（請求−支払）</div></div>
        <div class="bl-kpi"><div class="k">消費税（請求）</div><div class="v">${YEN(tb.tax)}</div><div class="k">立替通行料 ${YEN(tb.toll)}</div></div>
      </div>
      <div class="bl-grid">${panel('seikyu', seikyu)}${panel('shiharai', shiharai)}</div>
      <div class="bl-note">
        運賃・傭車料は税抜、消費税10%、通行料は立替（非課税）。相手先は名寄せ済み正式名称（コード＋枝番）、支払側はTマーク＝適格請求書登録番号あり。
        発行（お伺い書）は「運賃お伺い書」画面から。ここは月次の締め集計・突合ビュー。
        得意先行の「請求書」で、実物様式（A4横）の請求書を開けます。<b>請求書は通行料を内税として計算する</b>ため、
        この表の合計（通行料＝非課税の立替）とは金額の内訳が異なります。
      </div>
    </section>`
  el.querySelector('#bl-month').addEventListener('change', (e) => { B.month = setSelectedMonth(e.target.value) || e.target.value; paint() })
}
